import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Globals} from '@myApp/globals.ts';
import {ModalService} from '@myServices/modal.service';
import {EventService} from '@myServices/event.service';
import {AuthenticationService} from '@myServices/authentication.service';
import {OverlayService} from '@myServices/overlay.service';
import {LoginComponent} from '../../../Authentication/components/login/login.component';
import {NotificationService} from '@myServices/notification.service';
import {User} from '@myModels/User/user';
import {Router, NavigationEnd} from '@angular/router';
import {MgWalletComponent} from '../mg-wallet';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs/Subscription';
import {filter} from 'rxjs/operators';
import {TransactionService} from '@myServices/transaction.service';
import {ToastsManager} from 'ng2-toastr';
import {combineLatest} from 'rxjs/observable/combineLatest';
import {DecimalPipe} from '@angular/common';
import {JackpotService} from '@myServices/jackpot.service';
import {LocalService} from '@Shared/services';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css',
        '../jackpots-header/jackpots-header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

    public isMobile: boolean;
    public isSideBarOpen = false;
    public isLoggedIn: Boolean = false;
    public isOpenGameModal: Boolean = true;
    public depositting = false;
    public user: User;
    public balanceToggleStatus: Boolean = false;
    public dropDownVisible: Boolean = false;
    public selectedLang: any;
    public menuItems = [];
    private subscriptions: Subscription[] = [];
    currentRoute: string;


    constructor(
        private globals: Globals,
        private modalService: ModalService,
        private eventService: EventService,
        private authenticationService: AuthenticationService,
        private overlayService: OverlayService,
        private notificationService: NotificationService,
        private toastsManager: ToastsManager,
        private txService: TransactionService,
        private decimalPipe: DecimalPipe,
        private router: Router,
        private localService: LocalService,
        public translate: TranslateService,
        public jackpotService: JackpotService
    ) {
        this.initLanguage();

        this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
            this.currentRoute = event.url;
        });
    }

    public getDefaultMenus() {
        return [
            {name: 'MENU.LIVE_CASINO', path: '/live-casino', class: 'virtual-betting-header', icon: 'play_circle_filled'},
            {name: 'MENU.CASINO', path: '/casino', class: 'virtual-betting-header', icon: 'casino'},
            {
                name: 'MENU.NUMBER_GAMES',
                path: '/number-games',
                class: 'number-games',
                icon: 'money',
                hasBadge: true,
                badgeTitle: 'New'
            },
            {
                name: 'MENU.VIRTUALS',
                path: '/virtuals',
                class: 'virtuals',
                icon: 'desktop_mac',
                hasBadge: true,
                badgeTitle: 'New'
            },
        ];
    }

    public setMenuForAuthUser() {
        this.menuItems = [
            ...this.getDefaultMenus(),
            // {
            //     name: 'MENU.VIRTUAL_BETTING',
            //     path: '/virtual-sports',
            //     class: 'virtual-betting-header',
            //     icon: 'desktop_mac'
            // },
            {
                name: 'MENU.TV_BET',
                path: '/tv-bet',
                class: 'header-game',
                icon: 'tv',
                hasBadge: true,
                badgeTitle: 'New'
            },
            {
                name: 'MENU.BANK_RUN',
                path: '/header-game',
                class: 'header-game',
                icon: 'gamepad'
            },
            // {
            //     name: 'MENU.CRASH_GAMES',
            //     path: '/crash-games',
            //     class: 'crash-games',
            //     icon: 'desktop_mac',
            //     hasBadge: true,
            //     badgeTitle: 'New'            }
            ];
    }

    public setMenuForUnAuthUser() {
        this.menuItems = this.getDefaultMenus();
    }

    public setMenuForUser() {
        this.isLoggedIn ? this.setMenuForAuthUser() : this.setMenuForUnAuthUser();
    }

    ngOnInit() {
        const userInfoSubscription = this.eventService.getUserInfo().subscribe(data => {
            this.user = data.user;
        });
        this.setMenuForUser();
        this.subscriptions.push(userInfoSubscription);
        const authStatusSubscription = this.eventService.getAuthenticationStatus()
            .subscribe(data => {
                this.isLoggedIn = data.status;
                this.setMenuForUser();
            });
        this.subscriptions.push(authStatusSubscription);

        this.onResize();
        const sidebarStatusSubscription = this.globals.getSideBarStatus().subscribe(isSideBarOpen => {
            this.isSideBarOpen = isSideBarOpen;
        });
        this.subscriptions.push(sidebarStatusSubscription);
        const placeBalanceStatusSubscription = this.modalService._showHidePlayerBalance.subscribe(item => this.isOpenGameModal = item);
        this.subscriptions.push(placeBalanceStatusSubscription);
    }


    ngAfterViewInit(): void {
        this.initQRCodeSubscription();
    }

    openLoginModal() {
        const inputs = {
            isMobile: this.isMobile
        };
        this.modalService.init(LoginComponent, inputs, {});
    }

    logout() {
        this.authenticationService.currentGame = 0;
        this.overlayService.onOverlayChange(true);
        this.authenticationService.logout()
            .subscribe(response => {
                if (response.status) {
                    this.authenticationService.initializeSite()
                        .then(status => {
                            if (status) {
                                this.overlayService.onOverlayChange(false);
                                this.authenticationService.loginManager(response.data.user, false);
                                this.authenticationService.alive = false;
                                window.location.reload();
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            this.overlayService.onOverlayChange(false);
                        });

                }
            }, error => {
                this.overlayService.onOverlayChange(false);
                console.log(error);
                this.notificationService.error(error);
            });
    }

    balanceToggle() {
        this.balanceToggleStatus = !this.balanceToggleStatus;
    }

    closeModal() {
        this.modalService.destroy();
        document.body.classList.remove('game-modal-header');
        this.dropDownVisible = false;
    }

    toggleDropDown() {
        this.dropDownVisible = !this.dropDownVisible;
    }

    closeSiderBar() {
        this.globals.onSideBarChange(false);
    }

    toggleSideBar() {
        this.globals.onSideBarChange(!this.isSideBarOpen);
    }

    MgModalDesktop() {
        const inputs = {
            isMobile: false
        };
        this.modalService.init(MgWalletComponent, inputs, {});
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    private onResize() {
        const mobileStatusSubscription = this.globals.getMobileStatus().subscribe(isMobile => {
            this.isMobile = isMobile;
        });
        this.subscriptions.push(mobileStatusSubscription);
    }

    private initQRCodeSubscription() {
        const subscriptionDeposit = combineLatest(this.authenticationService.qrCode, this.eventService.getUserInfo())
            .pipe(filter(([qrCode]) => !!qrCode))
            .subscribe(([qrCode, user]) => {
                if (!!user && !!user.user) {
                    console.log('deposit', qrCode);
                    this.depositQRCode(qrCode);
                } else {
                    this.translate.get('MESSAGES.LOGIN_TO_DEPOSIT_QR').subscribe((msg) => {
                        this.toastsManager.error(msg, '', {fadeOut: 4000});
                    });
                    // directly calling this.openLoginModal(); is not working some how.
                    setTimeout(() => {
                        this.openLoginModal();
                    });
                }
            });
        this.subscriptions.push(subscriptionDeposit);
    }

    private depositQRCode(qrCode) {
        if (this.depositting) {
            return;
        }
        this.depositting = true;
        this.txService.qrDeposit(qrCode).subscribe((resp) => {
            this.depositting = false;
            const newFormattedBalance = this.decimalPipe.transform(resp.user.balance, '1.2-2') + ' ' + resp.user.currency;
            combineLatest(this.translate.get('TRANSACTION.DEPOSIT_SUCCESS'),
                this.translate.get('TRANSACTION.NEW_BALANCE', {balance: newFormattedBalance}))
                .subscribe(([newBalanceMsg]) => {
                    this.toastsManager.success(newBalanceMsg);
                });
            // navigate to remove qrCode from query params
            this.router.navigateByUrl('/');

        }, error => {
            this.depositting = false;
            this.translate.get(error.message).subscribe(msg => {
                this.toastsManager.error(msg);
            });
        });
    }

    private initLanguage() {
        this.translate.addLangs(this.localService.supportedLanguages);

        if (!this.localService.currentLang) {
            this.translate.use(this.localService.defaultLanguage);
            this.localService.currentLang = this.localService.defaultLanguage;
        }
        this.translate.use(this.localService.currentLang);
        this.selectedLang = this.localService.currentLang;
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/header/header.component.ts